export const dashboard = {
  title: "Dashboard",
  filters: {
    accommodation: "Alojamiento",
    allAccommodations: "Todos los alojamientos",
    period: "Periodo",
    periodOptions: {
      today: "Hoy",
      week: "Semana",
      month: "Mes",
      year: "Año",
    },
  },
  actions: {
    createBooking: "Crear reserva",
  },
  pendingWidget: {
  title: "Acciones pendientes",
  subtitle: "Pagos, solicitudes y habitaciones por asignar.",
  oneRequest: "solicitud",
  manyRequests: "solicitudes",
  onePayment: "pago",
  manyPayments: "pagos",
  oneUnassigned: "por asignar",
  manyUnassigned: "por asignar",
  loading: "Cargando acciones pendientes...",
  emptyTitle: "Sin acciones pendientes",
  emptyText: "Cuando entre una solicitud nueva o una reserva quede esperando pago, aparecerá aquí.",
  noName: "Sin nombre",
  accommodation: "Alojamiento",
  guest: "huésped",
  guests: "huéspedes",
  requestShort: "Solicitud",
  pendingPaymentShort: "Esperando pago",
  unassignedShort: "Asignar habitación",
  approve: "Aprobar",
  reject: "Rechazar",
  viewAll: "Ver todas las reservas",
  modalApproveTitle: "Aprobar solicitud",
  modalRejectTitle: "Rechazar solicitud",
  modalApproveText1: "Vas a aprobar la solicitud de",
  modalApproveText2: "Si esta reserva usa pago online, pasará a esperando pago.",
  modalRejectText1: "Vas a rechazar la solicitud de",
  modalRejectText2: "Puedes indicar el motivo para enviarlo al huésped por correo.",
  rejectReasonLabel: "Motivo del rechazo",
  rejectReasonPlaceholder: "Selecciona un motivo",
  reasonDatesUnavailable: "Las fechas ya no están disponibles",
  reasonPriceUnavailable: "La tarifa ya no está disponible",
  reasonMinimumStay: "No cumple la estancia mínima",
  reasonHouseRules: "No cumple las reglas del alojamiento",
  reasonOther: "Otro motivo",
  rejectReasonOtherPlaceholder: "Escribe el motivo del rechazo",
  rejectReasonRequired: "Debes seleccionar un motivo de rechazo.",
  rejectReasonOtherRequired: "Debes escribir el motivo del rechazo.",
  cancel: "Cancelar",
  confirmApprove: "Sí, aprobar",
  confirmReject: "Sí, rechazar",
  statusUpdatedSuccess: "Estado actualizado correctamente.",
  statusUpdatedError: "No se pudo actualizar el estado."
},

  stats: {
    totalReservations: {
      today:   "Reservas hoy",
      week:    "Reservas esta semana",
      month:   "Reservas del mes",
      year:    "Reservas del año",
      default: "Total reservas",
    },
    checkIns: {
      today:   "Check-ins hoy",
      week:    "Check-ins esta semana",
      month:   "Check-ins del mes",
      year:    "Check-ins del año",
      default: "Check-ins",
    },
    occupancy: {
      today:   "Ocupación hoy",
      week:    "Ocupación semanal",
      month:   "Ocupación mensual",
      year:    "Ocupación anual",
      default: "Ocupación",
    },
    revenue: {
      today:   "Facturación de hoy",
      week:    "Facturación semanal",
      month:   "Facturación mensual",
      year:    "Facturación anual",
      default: "Facturación",
    },
  },
  section3: {
    title: "Próximas llegadas",
    subtitle: "Listado de reservas próximas por llegada en tu alojamiento",
    timeFilters: {
      upcoming: "Próximas",
      thisWeek: "Esta semana",
      today: "Hoy",
      tomorrow: "Mañana",
      month: "Mes",
    },
    table: {
      headers: {
        responsible: "Responsable",
        checkInDate: "Fecha de entrada",
        entry: "Entrada",
        guests: "Huéspedes",
        status: "Estado check-in",
      },
    },
    empty: {
      today: {
        title: "No tienes llegadas para hoy",
        description:
          "Cuando tengas una nueva llegada programada para hoy, la verás aquí con sus detalles importantes.",
      },
      default: {
        title: "No tienes próximas llegadas",
        description:
          "Cuando tengas nuevas llegadas programadas, aparecerán aquí junto con sus detalles importantes.",
      },
    },
    loading: "Cargando reservas...",
    statuses: {
      inProgress: "En proceso",
      complete: "Completa",
      pending: "Pendiente",
      approved: "Aprobada",
    },
    actions: {
      replyOnWhatsApp: "Responder en WhatsApp",
    },
    // Pluralización (vue-i18n v8 con pipes)
    // choiceIndex = número de noches
    nights: "{count} noche | {count} noches",
  },
  section4: {
    title: "Desglose de ingresos",
    total: "Ingresos Totales",
    emptyChart: "Sin datos disponibles",
    noData: "No hay datos de ingresos para mostrar",
  },

  section5: {
    title: "Total de ingresos",
    datasetLabel: "Ingresos",
    filters: {
      weekly: "Semanal",
      monthly: "Mensual",
      "6m": "6 Meses",
      "12m": "12 Meses",
      "24m": "24 Meses",
    },
    loading: "Cargando datos...",
    errors: {
      load: "Error al cargar los datos",
      connection: "Error de conexión",
    },
  },
  design: {
    title: `Diseño del panel`,
    reorder: `Reordenar`,
    active: `Activo`,
    theme: `Tema`,
    color: `Color`,
    green: `Verde`,
    system: `System`,
    white: `Blanco`,
    sidebar: `Barra lateral`,
    black: `Negro`,
  },
  earlyCheckin: {
    earlyShort: `Antes`,
    arrivesShort: `Llega`,
    arrivalAt: `A las {time}`,
    requested: `Early check-in solicitado`,
    arrivalRequested: `Hora de llegada solicitada`,
  },
};
